import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import codes from '@/codes';
import { Switch as cSwitch } from '@coreui/vue';
import moment from 'moment-timezone';
import vSelect from 'vue-select';
import auth from '@/service/auth';

//restful api
import { group as manager } from '@/service/api/manager'

let default_opt = function() {
  return {
    perPage: 15,
    currentPage: 1, totalRows: 0,
    sk: '', sv: '', skt: '', opt : {}, adv : false
  }
}

const i18n_fields = {
  EN: [
    { key: 'id', label: '#.', sortable: false, thStyle: 'width: 10%' },
    { key: 'joined_at', label: 'Join_at', sortable: true },
    { key: 'is_alive', label: 'Allow login', sortable: false },
    { key: 'groupname', label: 'Name', sortable: true },
    { key: 'count', label: 'User', sortable: true },
    { key: 'service', label: 'Service', sortable: false },
  ],
  KO: [
    { key: 'id', label: '#.', sortable: false, thStyle: 'width: 10%' },
    { key: 'joined_at', label: '가입일', sortable: true },
    { key: 'is_alive', label: '로그인 허용', sortable: false },
    { key: 'groupname', label: '이름', sortable: true },
    { key: 'count', label: '계정 수(사용자 수)', sortable: true },
    { key: 'service', label: '서비스', sortable: false },
  ]
}

export default {
  components: { DatePicker, cSwitch, vSelect },
  name : "groupList",
  props : ["auto_refresh", "enable_new", "view_detail", "partner", "addPartner"],
  data: () => ({
    auth,
    hide_del : true,
    custom,
    codes,
    so : default_opt(),
    model : { total : 0, enable : 0, disable : 0 }, //enable : is_alive 기준, disable : is_del 기준
    sync : { interval : 15, stop : false, th : undefined },
    nbsp: "\u00A0"
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return i18n_fields[this.i18n]
    }
  },
  methods: {
    has_permissions() { return this.enable_new !== false && ((this.partner && this.partner.id) || auth.profile.permissions.toLowerCase() != 'sales')  },
    change_del($event) { if($event == true || $event == false) { this.so.opt['is_del'] = $event; this.refresh(); } },
    change_alive($event) { if($event == true || $event == false) { this.so.opt['is_alive'] = $event; this.refresh(); } },
    addWithPartner() {
      if(this.addPartner === true) {
        this.$router.push({ name: 'group', params: { id : this.$route.params.id, tag : "partner" } })
      } else {
        this.$router.push({ name: 'group', params: { id : 'add' } })
      }
    },
    set_sd(v, k = 'joined_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['joined_at_ed'] = moment();
        this.so.opt['service'] = "Basic";
        this.so.opt['match_type'] = 'and';
        this.so.opt['is_verified'] = 'true';

        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k == 'permissions') {
        return { name : k, value : v, op : '=' };
      } else if(v == 'false' || v == 'true' || (k.length > 2 && k.substring(0, 2) == "is")) {
        return { name : k, value : v == false ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th && this.sync.stop) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let and = [  ]
      let so = {
        body : {
          sort : [{ name : "id", op : "desc" }],
          or : [],
          and : and
        },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }

      // if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ); }
      if(this.partner) { so.body.and.push({ name : "partner_id", Value : this.partner.id, op : "=" }) }
      if(this.hide_del) { so.body.and.push({ name : 'is_del', value : false, op : '=' }); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_verified':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'joined_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 9), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'joined_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 9), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return manager.listGroup(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    summary() {
      manager.summaryGroup(Object.assign({}, this.partner ? { params : { id : this.partner.id, ts : new Date().getTime() }} : { ts : new Date().getTime()} ))
        .then(rs => { this.model = Object.assign(this.model, { enable : (rs.body.total - rs.body.disable), disable : rs.body.disable, total : rs.body.total }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    goDetail(item) {
      this.view_detail == false ? this.$root.$emit('select', item) : this.$router.push({ name : 'group', params : { id : item.id } });
    },
    sv_reset(){
      if(this.so.sv != ''){
        this.so.sv = ''
        return this.so.sv
      }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.$on('refresh', this.refresh()) } },
  created() { console.log('group.list.vue', 'created'); },
  destroyed() { console.log('group.list.vue', 'destroyed'); },
  mounted() { console.log('group.list.vue', 'mounted');
    if(this.view_detail !== false) { setTimeout(this.summary, 1000) }
  },
}